import { items } from './server/item.json';
import { recipes } from './server/recipe.json';
import { stores } from './server/store.json';

export type Prize = {
  prize_id: string;
  recipe_id: string;
  display_name: string;
  image_url: string;
  coin_price: number;
  store_order: number;
  store_delivery: string | null;
};
export const PRIZE_LIST: Prize[] = [];
export default {
  PRIZE_LIST,
};

const product_list =
  stores && stores.store_default && stores.store_default.product_list;
product_list.forEach(recipe_id => {
  const recipe = recipes[recipe_id];
  const item_id = recipe.output[0].item_id;
  const item = items[item_id];

  if (!item.extra.store_hidden) {
    PRIZE_LIST.push({
      prize_id: item_id,
      recipe_id: recipe_id,
      display_name: item.extra.store_name,
      image_url: item.extra.store_image_url,
      coin_price: recipe.input[0].quantity,
      store_order: item.extra.store_order,
      store_delivery: item.extra.store_delivery,
    });
  }
});
PRIZE_LIST.sort(_sortPrizes);

function _sortPrizes(a, b) {
  return a.store_order - b.store_order;
}
